import {mapToMaterialsById, useMaterials} from '@domain/materials'
import {Card} from '@hconnect/uikit/src/lib2'
import {useUpmPlantTimezone, useUpmPlantContext} from '@hconnect/upm'
import {Skeleton, Stack} from '@mui/material'

import {useMaterialDemandDailyQuery, useMaterialDemandPerMaterialQuery} from '../hooks'
import {useMaterialDemandFilters, useSelectedTimeframe} from '../providers'

import {MaterialDemandChart} from './MaterialDemandChart'
import {MaterialDemandTable, MaterialDemandTableToolbar} from './table'

export const MaterialDemandCard = () => {
  const {selectedTimeframe} = useSelectedTimeframe()
  if (!selectedTimeframe) {
    throw new Error('BUG: Selected timeframe should be set to render this view')
  }
  const {selectedMaterialIds, selectedDate} = useMaterialDemandFilters()
  const timezoneId = useUpmPlantTimezone()
  const {data: materialDemandDaily} = useMaterialDemandDailyQuery({
    materialIds: selectedMaterialIds,
    timeframe: selectedTimeframe,
    timezoneId
  })
  const {data: materialDemandPerMaterial} = useMaterialDemandPerMaterialQuery({
    timeFrame: selectedTimeframe,
    timezoneId,
    selectedDate
  })

  const {plantId: plantCode} = useUpmPlantContext()
  const {data: materialsById} = useMaterials({
    plantCode,
    options: {select: mapToMaterialsById}
  })

  return (
    <Card>
      <Stack spacing={4}>
        <MaterialDemandChart
          demandData={materialDemandDaily}
          timeFrame={selectedTimeframe}
          timezoneId={timezoneId}
        />
        <Stack spacing={1}>
          <MaterialDemandTableToolbar />
          {materialDemandPerMaterial ? (
            <MaterialDemandTable
              demandData={materialDemandPerMaterial}
              materialsById={materialsById}
            />
          ) : (
            <Skeleton variant="rectangular" height={400} />
          )}
        </Stack>
      </Stack>
    </Card>
  )
}
